const customerInitialState = {};

export default customerInitialState;



// WEBPACK FOOTER //
// ./src/app/FormStepper/customerInitialState.js